import { create } from "zustand";
import { devtools } from "zustand/middleware";
import createSelectors from "./selectors";
import {fontColorVariants} from "../utils/consts";

type HighLightType = {
  type: string;
  color: string;
  line: string;
}

interface EditorPanelButtonState {
  isSignatureModalOpen: boolean;
  setIsSignatureModalOpen: (isSignatureModalOpen: boolean) => void;

  signatureList: any[];
  setSignatureList: (signaturesList: any[]) => void;

  isImageModalOpen: boolean;
  setIsImageModalOpen: (isImageModalOpen: boolean) => void;

  imageList: any[];
  setImageList: (imageList: any[]) => void;

  isOpenModal: string;
  setIsOpenModal: (isOpenModal: string) => void;

  colors: string[];
  setColors: (colors: string[]) => void;

  tab: string;
  setTab: (tab: string) => void;

  highlight: HighLightType;
  setHighlight: (tab: HighLightType) => void;
}

const useEditorPanelButtonStore = create<EditorPanelButtonState>()(
  devtools(
    (set) => ({
      isSignatureModalOpen: false,
      isImageModalOpen: false,
      signatureList: [],
      imageList: [],
      isOpenModal: '',
      colors: fontColorVariants,
      tab: '',
      highlight: {type: '', color: 'transparent', line: '1'},

      setIsSignatureModalOpen: (isSignatureModalOpen: boolean) =>
        set({ isSignatureModalOpen }),

      setSignatureList: (signatureList) =>
        set({ signatureList }),

      setIsImageModalOpen: (isImageModalOpen: boolean) =>
        set({ isImageModalOpen }),

      setImageList: (imageList) => {
        set({ imageList });
      },

      setIsOpenModal: (isOpenModal: string) =>
        set({ isOpenModal }),

      setColors: (colors: string[]) =>
        set({colors}),

      setTab: (tab: string) =>
        set({ tab }),

      setHighlight: (highlight: HighLightType) =>
        set({ highlight }),
    }),
    { name: "editor-panel-button-store" }
  )
);

export default createSelectors(useEditorPanelButtonStore);
